module.exports = __webpack_public_path__ + "img/jili.aa331f95.png";